module.exports = __webpack_public_path__ + "static/media/cafe_master.cc42ba6d.png";